// extracted by mini-css-extract-plugin
export var formContainer = "_jj-0";
export var message = "_jj-1";